export default __webpack_public_path__ + "static/media/cloudsmith-logo.45cb58a5.svg";